import { z } from 'zod/mini';

export const BookingContactResponseSchema = z.object({
  message: z.string(),
});
